export default __webpack_public_path__ + "3e88f19e44fc230a98fa945c5a7a797c.png";